import { makeStyles } from "@material-ui/core";

export const useViolationModalStyles = makeStyles((theme) => ({
    title: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}))